module.exports = __webpack_public_path__ + "static/media/adidas_logo.bb1afe1a.png";